"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const BlankButton_1 = require("../Button/BlankButton");
const classnames_1 = __importDefault(require("classnames"));
const Typography_1 = require("../Typography/Typography");
function LinkComp(_a, ref) {
    var { children, size = 'medium', disabled } = _a, linkProps = __rest(_a, ["children", "size", "disabled"]);
    return ((0, jsx_runtime_1.jsx)(BlankButton_1.BlankButton, Object.assign({ ref: ref, roundedBorder: false, disabled: disabled, className: (0, classnames_1.default)({
            'text-silver-40': disabled,
            'text-blue-80 hover:underline hover:underline-offset-4 hover:decoration-2': !disabled,
        }) }, linkProps, { children: (0, jsx_runtime_1.jsx)(Typography_1.Typography, Object.assign({ variant: `${size === 'small' ? 'h100' : 'h300'}` }, { children: children })) })));
}
exports.Link = (0, react_1.forwardRef)(LinkComp);
//# sourceMappingURL=Link.js.map